<div class="color-picker-wrapper">
  <input
    [(colorPicker)]="color"
    (colorPickerChange)="handleColorChange($event)"
    [formControl]="colorPickerFormControl"
    [style.background]="selectedColor"
    [cpEyeDropper]="true"
    [cpSaveClickOutside]="true"
    [cpOutputFormat]="'rgba'"
    [cpUseRootViewContainer]="cpUseRootViewContainer"
    [cpDialogDisplay]="cpDialogDisplay"
    readonly
  />
  <div class="color-picker-title">
    {{ selectedColor | rgbaToHex }}
  </div>
</div>
